import * as authTypes from '../types/authTypes';
import * as authServices from '../../services/authServices';

export function loginUser(userData) {
  return async function (dispatch) {
    dispatch({ type: authTypes.LOGIN_REQUEST });
    try {
      const data = await authServices.loginUser(userData);
      dispatch({ type: authTypes.LOGIN_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: authTypes.LOGIN_FAILURE, payload: error.message });
    }
  };
}

export function signupUser(userData) {
  return async function (dispatch) {
    dispatch({ type: authTypes.SIGNUP_REQUEST });
    try {
      const data = await authServices.signupUser(userData);
      dispatch({ type: authTypes.SIGNUP_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: authTypes.SIGNUP_FAILURE, payload: error.message });
    }
  };
}

export function fetchMe() {
  return async function (dispatch) {
    dispatch({ type: authTypes.ME_REQUEST });
    try {
      const data = await authServices.getMe();
      dispatch({ type: authTypes.ME_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: authTypes.ME_FAILURE, payload: error.message });
    }
  };
}

export function updateMeProfile(profileData) {
  return async function (dispatch) {
    try {
      const user = await authServices.updateMe(profileData);
      dispatch({ type: authTypes.ME_SUCCESS, payload: user });
      return { success: true, user };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };
}

export function forgotPasswordAction(email) {
  return async function (dispatch) {
    dispatch({ type: authTypes.FORGOT_PASSWORD_REQUEST });
    try {
      const data = await authServices.forgotPassword(email);
      dispatch({ type: authTypes.FORGOT_PASSWORD_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: authTypes.FORGOT_PASSWORD_FAILURE, payload: error.message });
    }
  };
}

export function resetPasswordAction(data) {
  return async function (dispatch) {
    dispatch({ type: authTypes.RESET_PASSWORD_REQUEST });
    try {
      const result = await authServices.resetPassword(data);
      dispatch({ type: authTypes.RESET_PASSWORD_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: authTypes.RESET_PASSWORD_FAILURE, payload: error.message });
    }
  };
}

export function logout() {
  return function (dispatch) {
    dispatch({ type: authTypes.LOGOUT });
  };
}

export function clearAuthError() {
  return function (dispatch) {
    dispatch({ type: authTypes.CLEAR_AUTH_ERROR });
  };
}
